export * from './authApi.service';
import { AuthApiService } from './authApi.service';
export * from './clientLogApi.service';
import { ClientLogApiService } from './clientLogApi.service';
export * from './dateiViewApi.service';
import { DateiViewApiService } from './dateiViewApi.service';
export * from './kontaktApi.service';
import { KontaktApiService } from './kontaktApi.service';
export * from './kursInfoApi.service';
import { KursInfoApiService } from './kursInfoApi.service';
export * from './kursanmeldungApi.service';
import { KursanmeldungApiService } from './kursanmeldungApi.service';
export * from './pageViewApi.service';
import { PageViewApiService } from './pageViewApi.service';
export * from './passwortResetApi.service';
import { PasswortResetApiService } from './passwortResetApi.service';
export * from './propertiesApi.service';
import { PropertiesApiService } from './propertiesApi.service';
export * from './teilnehmerApi.service';
import { TeilnehmerApiService } from './teilnehmerApi.service';
export const APIS = [AuthApiService, ClientLogApiService, DateiViewApiService, KontaktApiService, KursInfoApiService, KursanmeldungApiService, PageViewApiService, PasswortResetApiService, PropertiesApiService, TeilnehmerApiService];
